var map = {
	"./FFFLogo.png": "36c3",
	"./TM_INTERVIEW.png": "4b0d",
	"./TeamsMagicBG1.png": "bf90",
	"./cheating_design.png": "97fc",
	"./circleDesign.png": "810f",
	"./circleDesign2.png": "57c3",
	"./circleDesign3.png": "64a2",
	"./circleDesign4.png": "9c99",
	"./cloud_design.png": "7fc3",
	"./coin.png": "1d54",
	"./crown.png": "370f",
	"./customize_layouts1.png": "f0fe",
	"./escapeRoomImg.png": "6f45",
	"./funActivitiesLogo.png": "0ea3",
	"./fun_activities1.png": "aeb2",
	"./fun_activities2.png": "81f0",
	"./fun_activities3.png": "f3e8",
	"./fun_activities4.png": "264f",
	"./fun_activities5.png": "1066",
	"./fun_activities6.png": "09a3",
	"./gameBg.png": "085d",
	"./games_thumnails.png": "6b85",
	"./home_img1.png": "e413",
	"./home_img2.png": "ac8e",
	"./home_img3.png": "f8b2",
	"./home_img4.png": "a05c",
	"./img_avatar2.png": "764d",
	"./info_bg1.png": "1f99",
	"./join_bg1.png": "974b",
	"./join_inter_bg2.png": "ee4b",
	"./lang_logos.png": "543f",
	"./letsConnect.png": "a931",
	"./library_pc.png": "ed13",
	"./loginBgImg.png": "d4ea",
	"./loginPageLogo.png": "3e78",
	"./loginPageLogoold.png": "ef47",
	"./logoIcon.png": "6277",
	"./logoWhite.png": "ff87",
	"./magicPicture.png": "1bff",
	"./magicPictureImg2.png": "2a13",
	"./mediattionLogo.png": "1c49",
	"./meditationLogo1.png": "7240",
	"./mystery_logo.png": "1d4a",
	"./planeWhiteShapeBg.png": "a4ea",
	"./promo_thumnail_1.png": "0330",
	"./quiz2.png": "7677",
	"./quiz_game.png": "f0cd",
	"./scribble1.png": "cdda",
	"./scribble2.png": "7375",
	"./scribbleLogo.png": "5b17",
	"./scrible_chart.png": "2132",
	"./scrible_logo.png": "405c",
	"./tm_cheering.png": "db28",
	"./tm_interview_main_bg1.png": "92fe",
	"./tm_works.png": "287b",
	"./treasureHuntImg.png": "8f20",
	"./upcoming_logo.png": "dc24"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";